import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceListNotifierComponent } from './price-list-notifier.component';
import { PriceListDomainModule } from 'app/domains/price-list/price-list-domain.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    PriceListNotifierComponent
  ],
  exports: [
    PriceListNotifierComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    PriceListDomainModule
  ]
})
export class PriceListNotifierModule { }
